
import { FaTools } from "react-icons/fa";

const StatusMessage = () => {
    return (

        <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-gradient-to-b from-primary-300 to-secondary-300 text-white">

            {/* Animated Icon */}
            <div className="flex items-center justify-center mb-6">
                <FaTools className="text-6xl animate-pulse drop-shadow-lg" />
            </div>

            {/* Title */}
            <h1 className="text-3xl md:text-4xl font-bold mb-3 tracking-wide">
                We’re Polishing Things Up
            </h1>

            {/* Subtitle */}
            <p className="text-base md:text-lg max-w-md text-white/90 leading-relaxed">
                Our system is currently under a quick maintenance to make your experience smoother and faster.
                We’ll be back shortly — please visit again soon!
            </p>

            {/* Gentle Divider */}
            <div className="mt-8 w-24 h-1 bg-white/60 rounded-full animate-pulse"></div>

            {/* Footer Note */}
            <p className="text-sm text-white/70 mt-6">
                Thank you for your patience and understanding
            </p>
        </div>

    );
};

export default StatusMessage;
